<div class="archive-margin-main" role="contentinfo">
  <article aria-label="archive-header" class="specialcase-header" [innerHTML]="archive_header"></article>
  <article class="mt-2 archive-Info" [innerHTML]="archive_body"></article>
  <div class="mt-2 archive-warning-rectangle archiveBox flex-display">
    <div class="ptbl-32">
      <img src="../../../../assets/icons/warning-orange.svg" class="info-img" alt="Warning Icon">
    </div>
    <article class="ptbr-32 infoWarning" [innerHTML]="archive_note"></article>
  </div>
  <div class="version-group" *ngIf="fasbversions != null && this.normalUrl != ''">
    <p class="version-general-header" tabindex="0">{{archive_fasbContent}}</p>
    <div *ngIf="fasbversions.length == 0" tabindex="0">{{archive_noVersionFound}}</div>
    <div *ngFor="let fasb of fasbversions">
      <article class="version-general-header" [innerHTML]='fasb.title.split(": ")[1]' tabindex="0"></article>
      <div class="mt-8px" *ngIf="fasb.versions.length > 0" tabindex="0">
        <ul>
          <li *ngFor="let version of fasb.versions" class="basic-access-btn">
            <span class="h-20px highlight-blue border-bottom-help cursor-pointer" (click)="GoToVersion(version)" (keyup.enter)="GoToVersion(version)" tabindex="0">Version {{version.revision}}</span>&nbsp;|&nbsp;
            <span class="archive-Info opacity-5" *ngIf="version.expiryDate != ''">{{archive_supersededOn}}</span>
            <span class="archive-Info" *ngIf="version.expiryDate == ''">Current</span>&nbsp;
            <span class="archive-Info" *ngIf="version.expiryDate != ''">{{version.expiryDate}}</span>
          </li>
        </ul>
      </div>
      <div *ngIf="fasb.versions.length == 0">
        <p class="archive-Info" tabindex="0">No archive found.</p>
      </div>
    </div>
  </div>
  <div class="version-group" *ngIf="secversions != null && this.secUrl != ''">
    <p class="version-general-header" tabindex="0">{{archive_secContent}}</p>
    <div *ngIf="secversions.length == 0" tabindex="0">{{archive_noVersionFound}}</div>
    <div *ngFor="let sec of secversions">
      <article class="version-general-header" [innerHTML]='sec.title.split(": ")[1]' tabindex="0"></article>
      <div class="mt-8px" *ngIf="sec.versions.length > 0">
        <ul>
          <li *ngFor="let version of sec.versions" class="basic-access-btn">
            <span class="h-20px highlight-blue border-bottom-help cursor-pointer" (click)="GoToVersion(version)" (keyup.enter)="GoToVersion(version)" tabindex="0">Version {{version.revision}}</span>&nbsp;|&nbsp;
            <span class="archive-Info opacity-5" *ngIf="version.expiryDate != ''">{{archive_supersededOn}}</span>
            <span class="archive-Info" *ngIf="version.expiryDate == ''">Current</span>&nbsp;
            <span class="archive-Info" *ngIf="version.expiryDate != ''">{{version.expiryDate}}</span>
          </li>
        </ul>
      </div>
      <div *ngIf="sec.versions.length == 0">
        <p class="archive-Info" tabindex="0">No archive found.</p>
      </div>
    </div>
  </div>
</div>
